import { render, staticRenderFns } from "./WaitingList.vue?vue&type=template&id=1b8a9414&scoped=true&"
import script from "./WaitingList.vue?vue&type=script&lang=ts&"
export * from "./WaitingList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8a9414",
  null
  
)

export default component.exports